var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/login"}},[_c('div',{attrs:{"id":"bg"},on:{"click":function($event){_vm.stop = true}}},[_c('div',{attrs:{"id":"img"}},[_c('img',{attrs:{"src":require("./../assets/images/igroove-logo.svg")}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }